module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/tv/tv.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/tv/tv.png
// module id = 644
// module chunks = 0